export const login = {
  loginSuccessfully: 'Login Successfully',
  loginError: 'Password or UserId is incorrect',
}
